import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const PHONE    = '9445879508';
const WA_PHONE = '919445879508';

const tourTypes = [
  { icon:'💑', title:'Honeymoon Tours',   desc:'Romantic packages for newlyweds — Kodaikanal, Ooty, Munnar & Kanyakumari.', tag:'Most Popular' },
  { icon:'👨‍👩‍👧‍👦', title:'Family Tours',      desc:'Kid-friendly itineraries with comfortable vehicles for the whole family.' },
  { icon:'🎒', title:'Group Tours',       desc:'Best group rates for college trips, office outings and community travel.' },
  { icon:'🙏', title:'Pilgrimage Tours',  desc:'Rameswaram, Sabarimala, Tirupati, Srirangam, Palani & Velankanni packages.' },
  { icon:'🌿', title:'Hill Station Tours',desc:'Kodaikanal, Ooty, Munnar — three stunning hill stations in South India.' },
  { icon:'🏢', title:'Corporate Tours',   desc:'Smooth, on-time corporate transport with invoice and GST billing available.' },
];

const destinations = [
  { name:'Kodaikanal', icon:'🏔️', img:'https://images.unsplash.com/photo-1589308078059-be1415eab4c3?w=500&q=80', tag:'Base Route' },
  { name:'Madurai',    icon:'🛕', img:'https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=500&q=80', tag:'Temple City' },
  { name:'Rameswaram', icon:'🌊', img:'https://images.unsplash.com/photo-1567157577867-05ccb1388e66?w=500&q=80', tag:'Sacred Island' },
  { name:'Munnar',     icon:'🍃', img:'https://images.unsplash.com/photo-1605649487212-47bdab064df7?w=500&q=80', tag:'Kerala Hills' },
  { name:'Ooty',       icon:'🚂', img:'https://images.unsplash.com/photo-1595658658481-d53d3f999875?w=500&q=80', tag:'Queen of Hills' },
  { name:'Sabarimala', icon:'🙏', img:'https://images.unsplash.com/photo-1561361058-c24e285d8324?w=500&q=80', tag:'Pilgrimage' },
  { name:'Srirangam',  icon:'🛕', img:'https://images.unsplash.com/photo-1590123716139-5bce4e6ab1fa?w=500&q=80', tag:'Divya Desam' },
  { name:'Kanyakumari',icon:'🌅', img:'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=500&q=80', tag:"Land's End" },
  { name:'Velankanni', icon:'⛪', img:'https://images.unsplash.com/photo-1501854140801-50d01698950b?w=500&q=80', tag:'Shrine Basilica' },
  { name:'Tirupati',   icon:'🙏', img:'https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=500&q=80', tag:'Divya Desam' },
  { name:'Palani',     icon:'🛕', img:'https://images.unsplash.com/photo-1561361058-c24e285d8324?w=500&q=80', tag:'Murugan Temple' },
];

const vehicles = [
  { name:'4-Seater Car',  seats:'4',  img:'https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=500&q=80', type:'Swift Dzire / Etios', best:'Couples & Small Families' },
  { name:'7-Seater SUV',  seats:'7',  img:'https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=500&q=80', type:'Innova / Ertiga',      best:'Families' },
  { name:'12-Seater Van', seats:'12', img:'https://images.unsplash.com/photo-1558979158-65a1eaa08691?w=500&q=80', type:'Force Traveller',      best:'Large Groups' },
  { name:'25-Seater Bus', seats:'25', img:'https://images.unsplash.com/photo-1570125909232-eb263c188f7e?w=500&q=80', type:'Mini Coach',          best:'Group Tours' },
];

export default function Home() {
  return (
    <div className="home page-enter">

      {/* ── HERO ── */}
      <section className="hero">
        <div className="hero__bg" />
        <div className="hero__overlay" />
        <div className="hero__content container">
          <div className="hero__badge fade-up">🏔️ Kodai Road ↔ Kodaikanal — Est. 2003</div>
          <h1 className="hero__title fade-up delay-1">
            Explore South India<br />
            with <em>Maggi Cabs</em>
          </h1>
          <p className="hero__desc fade-up delay-2">
            From Kodaikanal to Kanyakumari, Rameswaram to Munnar — trusted tours across
            South India since 2003. Call Anbu Kumar anytime.
          </p>
          <div className="hero__ctas fade-up delay-3">
            <a href={`https://wa.me/${WA_PHONE}?text=Hi%20Anbu%20Kumar!%20I%20want%20to%20book%20a%20tour.`}
               target="_blank" rel="noreferrer" className="btn-primary">
              💬 Book on WhatsApp
            </a>
            <a href={`tel:+91${PHONE}`} className="btn-outline">
              📞 Call +91 {PHONE}
            </a>
          </div>
        </div>
        <div className="hero__stats">
          <div className="container hero__stats-inner">
            {[['20+','Years'],['75','Destinations'],['79+','Tour Packages'],['24/7','Available']].map(([n,l]) => (
              <div key={l} className="hero__stat">
                <strong>{n}</strong><span>{l}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── QUICK CALL ── */}
      <section className="quick-book">
        <div className="container quick-book__inner">
          <div className="quick-book__text"><strong>Anbu Kumar:</strong> Available 24/7 for all bookings</div>
          <div className="quick-book__actions">
            <a href={`tel:+91${PHONE}`} className="btn-green">📞 +91 {PHONE}</a>
            <a href={`https://wa.me/${WA_PHONE}`} target="_blank" rel="noreferrer" className="btn-primary">💬 WhatsApp</a>
          </div>
        </div>
      </section>

      {/* ── DESTINATIONS ── */}
      <section className="section-pad">
        <div className="container">
          <div className="section-header">
            <div>
              <p className="eyebrow">Where We Go</p>
              <h2 className="display-title">Our Destinations</h2>
              <div className="amber-line" />
            </div>
            <Link to="/tours" className="btn-green">View All Tours →</Link>
          </div>
          <div className="home-dest-grid">
            {destinations.map(d => (
              <Link key={d.name} to={`/tours`} className="home-dest-card">
                <img src={d.img} alt={d.name} loading="lazy" />
                <div className="home-dest-overlay" />
                <div className="home-dest-body">
                  <span className="home-dest-tag">{d.tag}</span>
                  <span className="home-dest-icon">{d.icon}</span>
                  <span className="home-dest-name">{d.name}</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* ── TOUR TYPES ── */}
      <section className="section-pad" style={{background:'#f2f8f5'}}>
        <div className="container">
          <div className="text-center">
            <p className="eyebrow">What We Offer</p>
            <h2 className="display-title">Tour Packages</h2>
            <div className="amber-line center" />
            <p className="section-desc">Honeymoon, family, pilgrimage, group — we have the right package for every journey.</p>
          </div>
          <div className="tours-grid">
            {tourTypes.map(t => (
              <div key={t.title} className="tour-card card">
                {t.tag && <span className="tour-card__tag">{t.tag}</span>}
                <div className="tour-card__icon">{t.icon}</div>
                <h3 className="tour-card__title">{t.title}</h3>
                <p className="tour-card__desc">{t.desc}</p>
                <Link to="/tours" className="tour-card__cta">Explore Packages →</Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── FLEET ── */}
      <section className="section-pad fleet-section">
        <div className="container">
          <div className="text-center">
            <p className="eyebrow">Travel in Comfort</p>
            <h2 className="display-title">Our Fleet</h2>
            <div className="amber-line center" />
            <p className="section-desc">4 vehicle types for every group size — all AC, all maintained.</p>
          </div>
          <div className="fleet-grid">
            {vehicles.map(v => (
              <div key={v.name} className="vehicle-card card">
                <div className="vehicle-card__img">
                  <img src={v.img} alt={v.name} loading="lazy" />
                  <span className="vehicle-card__seats">👤 {v.seats} Seats</span>
                </div>
                <div className="vehicle-card__body">
                  <h3>{v.name}</h3>
                  <p className="vehicle-card__type">{v.type}</p>
                  <p className="vehicle-card__best">Best for: <strong>{v.best}</strong></p>
                  <a href={`https://wa.me/${WA_PHONE}?text=Hi!%20I'd%20like%20to%20book%20the%20${encodeURIComponent(v.name)}`}
                     target="_blank" rel="noreferrer" className="btn-primary">Book This Vehicle</a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── WHY US ── */}
      <section className="why-section section-pad">
        <div className="container">
          <div className="why-grid">
            <div className="why-content">
              <p className="eyebrow">Why Choose Maggi Cabs</p>
              <h2 className="display-title light">20+ Years on<br />South India Roads</h2>
              <div className="amber-line" />
              <p>Anbu Kumar has been running tours since 2003 — from the winding ghats to Kodaikanal, temple circuits to beach pilgrimages. His deep knowledge of every route means you're always safe and on time.</p>
              <div className="why-features">
                {['Experienced & Licensed Drivers','AC Vehicles — All Types','Transparent Pricing','24/7 Availability','75 Destinations Covered','Local Area Expertise'].map(f => (
                  <div key={f} className="why-feature">
                    <span className="why-feature__check">✓</span>{f}
                  </div>
                ))}
              </div>
              <a href={`tel:+91${PHONE}`} className="btn-primary" style={{marginTop:'1.5rem'}}>
                📞 Call Anbu Kumar Now
              </a>
            </div>
            <div className="why-image">
              <img src="https://images.unsplash.com/photo-1589308078059-be1415eab4c3?w=700&q=80" alt="Kodaikanal" />
              <div className="why-image__card">
                <strong>Anbu Kumar</strong>
                <span>Owner & Senior Driver</span>
                <span>Est. 2003</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── TESTIMONIALS ── */}
      <section className="section-pad">
        <div className="container">
          <div className="text-center">
            <p className="eyebrow">Happy Travellers</p>
            <h2 className="display-title">What Our Guests Say</h2>
            <div className="amber-line center" />
          </div>
          <div className="reviews-grid">
            {[
              { name:'Priya & Rahul',   loc:'Chennai',    stars:5, text:'Our Kodaikanal honeymoon was perfect! Anbu Kumar drove us safely through the mountain roads. Knew every scenic spot. Highly recommended!' },
              { name:'Karthik Family',  loc:'Coimbatore', stars:5, text:'Booked the 7-seater for Rameswaram. Comfortable vehicle, punctual driver, fair price. Will definitely book again!' },
              { name:'College Group',   loc:'Madurai',    stars:5, text:'Group trip to Ooty for 20 students. Got a great deal on the mini coach. Driver was patient and fun. Unforgettable trip!' },
              { name:'Suresh Kumar',    loc:'Bangalore',  stars:5, text:'Sabarimala pilgrimage arranged perfectly. On time to Pamba and pickup was smooth. Great service for such an important trip.' },
              { name:'Meena & Family',  loc:'Trichy',     stars:5, text:'Srirangam + Thanjavur in one day — perfectly planned. Second time using Maggi Cabs. Always trustworthy!' },
              { name:'IT Team Outing',  loc:'Salem',      stars:5, text:'Corporate trip to Munnar for 22 people. Zero issues — transport, timing, coordination. The team loved it!' },
            ].map((r,i) => (
              <div key={i} className="review-card card">
                <div className="review-card__stars">{'★'.repeat(r.stars)}</div>
                <p className="review-card__text">"{r.text}"</p>
                <div className="review-card__author">
                  <strong>{r.name}</strong>
                  <span>{r.loc}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="cta-section">
        <div className="cta-section__bg" />
        <div className="container cta-section__content">
          <p className="eyebrow">Ready to Explore?</p>
          <h2 className="display-title light">Book Your Tour Today!</h2>
          <p>Call or WhatsApp Anbu Kumar — 75 destinations, 79+ packages, 24/7 available.</p>
          <div className="cta-section__btns">
            <a href={`tel:+91${PHONE}`} className="btn-primary">📞 +91 {PHONE}</a>
            <a href={`https://wa.me/${WA_PHONE}`} target="_blank" rel="noreferrer" className="btn-outline">💬 WhatsApp</a>
          </div>
        </div>
      </section>
    </div>
  );
}
